import { cn } from '@/lib/utils'

/** The Xtellar mark. It stays brand red on every surface, dark included. */
export function XtellarMark({ className }: { className?: string }) {
  return (
    <img
      src="/xtellar-mark.png"
      alt=""
      aria-hidden="true"
      className={cn('h-5 w-auto shrink-0', className)}
    />
  )
}
